import React, { Component, PropTypes } from 'react';
import Banner from './layout/Banner';


export default class CV extends Component {

  render() {
    return (
      <div>
        <Banner />

        <iframe id="iframe-cv" src="https://drive.google.com/file/d/1xfEEr8P9okjXwr9_4kFAW1_DBrCPwfrr/preview" allow="autoplay"></iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CV.js